import './App.css';
import React, { Suspense, lazy, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useNavigate, useRoutes, useSearchParams, useLocation } from 'react-router-dom';
import ProgressBar from './components/common/ProgressBar'
import { logIn, updateLoadingScreen, log_in, loginData, menuVisible, roleData, updateUserData, logout, UpdateIpAddress, logoutUser, masterCodeAllValue, updateRevokeAndSeriveDate, LoginV3, sendOneDayPassword, setCounterId, getServerTime } from './redux/Actions';
import { decryptText } from './Decrypt';
import Alert from './components/common/Alert';
import LoaderScreen from './components/generics/Loader';
import { cargoroutes, ContSysRoute, dashboardRoute, defRoutes, routes } from './routes/routes';
import "./style/main.scss"
import KSRTCHeader from './components/KSRTC/Header';
import Footer from "./components/KSRTC/Footer"
import { Backdrop } from '@mui/material';
import Login from './components/KSRTC/Login';
import ConfirmCounter from './components/common/ConfirmCounter';
import { getCounterTableData, getMasterCodeSessionList, getplaceListAll } from './redux/KSRTC_Redux/MasterConfig/MasterAction';
import moment from 'moment';
import axios from 'axios';
import { getCompanyCityPairs } from './redux/KSRTC_Redux/bookingPage/bookingAction';
import { callGolbleData } from './globleTime';
import CrewReservationchartPrint from './components/CrewReservationchartPrint';
const ForgotPassword = lazy(() => import("./components/KSRTC/Login/forgotPassword"));

function App() {
  const [searchParams] = useSearchParams()
  const user = useSelector(state => state.user);
  const location = useLocation()

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState({ value: true, msg: "" })
  const [loginId, setLoginId] = useState("")
  const [showLoginId, setShowLoginId] = useState("")
  const [counterOpt, setCounterOpt] = useState([])
  const [selCounter, setSelCounter] = useState([])
  const [showCounter, SetShowCounter] = useState(false)
  const [showAlert1, setShowAlert1] = useState(false)
  const [passwordReset, setPasswordReset] = useState({
    oldPassword: '',
    open: false,
    GUID: '',
    LoginID: '',
    Password: '',
    ODP: '',
  })
  const [updateOdp, setUpdateOdp] = useState({
    open: false,
    LoginID: '',
    Password: '',
    GUID: '',
    ODP: '',
    phone: "",
    email: "",
  })
  const [loginError, setLoginError] = useState({ value: false, msg: "", isError: false })
  const feedbackId = decodeURIComponent(sessionStorage.getItem('FeedbackId') || '');

  // Define a function to check if the user is authenticated
  const filteredRoutes = useMemo(() => {
    if (user?.IsAdmin === 1) return routes;

    if (user?.roleData?.length > 0) {
      return routes.filter((route) => {
        const matchingCondition = user.roleData.find(
          (condition) =>
            route.MasterID === condition.MasterID &&
            route.jobID === condition.JobID
        );

        return (
          matchingCondition &&
          Array.isArray(route.condition) &&
          route.condition.some((val) => matchingCondition[val] === 1)
        );
      });
    }

    return [];
  }, [routes, user?.roleData, user?.IsAdmin, cargoroutes]);
  const filteredRoutesWithOutAdmin = useMemo(() => {
    if (user?.IsAdmin === 1) return cargoroutes;
    if (user?.roleData?.length > 0) {
      return cargoroutes.filter((route) => {
        const matchingCondition = user.roleData.find(
          (condition) =>
            route.MasterID === condition.MasterID &&
            route.jobID === condition.JobID
        );

        return (
          matchingCondition &&
          Array.isArray(route.condition) &&
          route.condition.some((val) => matchingCondition[val] === 1)
        );
      });
    }

    return [];
  }, [cargoroutes, user?.roleData, user?.IsAdmin]);
  let element = useRoutes([
    ...defRoutes,
    ...filteredRoutes,
    ...filteredRoutesWithOutAdmin,
    ...dashboardRoute,
    ...(user?.loginData?.RoleName?.toLowerCase() === "chief admin"
      ? ContSysRoute
      : []),
  ]);
  const fetchLogin = (body) => {
    dispatch(updateLoadingScreen(true));
    sessionStorage.setItem("LoginId", body.LoginID);
    dispatch(LoginV3('/LoginV2/PostV3', { ...body, Code: '' })).then((res) => {
      if (res?.data.Status == "true") {
        if (Number(res?.data?.Data?.Force) === 1) {
          setPasswordReset((prev) => ({
            ...prev,
            ...body,
            GUID: user?.ipAddress,
            oldPassword: body?.Password,
            open: true,
          }))
        } else {
          setUpdateOdp((prev) => ({
            ...prev,
            ...body,
            phone: res?.data?.Data?.MobileNo,
            email: res?.data?.Data?.EmailId,
            GUID: user?.ipAddress,
            open: true,
          }))
        }

      } else {
        setLoginError({ value: true, msg: res?.data?.ErrMessage, isError: true })
      }
    })

  }
  const callLoginApi = (body) => {
    const tokenDecode = decodeURIComponent(sessionStorage.getItem('XToken') || '');
    let macIdToken = decryptText(tokenDecode.replaceAll(" ", "+"))
    //console.log(macIdToken)
    const modifiedBody = {
      ...body,
      GUID: macIdToken ? macIdToken : body.GUID
    };
    dispatch(logIn("/LoginV2/PostV2", modifiedBody))
      .then(
        function (value) {
          if (value.Status == "true") {
            setPasswordReset((prev) => ({
              ...prev,
              open: false,
            }))
            setUpdateOdp((prev) => ({
              ...prev,
              open: false,
            }))
            if ((value?.Data?.CounterID === 0 && value?.Data?.AccessBranchID > 0) && !(value?.Data?.RoleName?.toLowerCase()?.includes('admin'))) {
              SetShowCounter(true)
              window.location.replace("/")
              if (feedbackId !== "") {
                navigate("/feedbackFromMail")
              } else {
                window.location.replace("/")
              }
            } else {
              // navigate("/displayNews")
              if (feedbackId !== "") {
                navigate("/feedbackFromMail")
              } else {
                window.location.replace("/displayNews")
              }
            }
            console.log(' version 4.040909')
          }
          else {
            setLoginError({ value: true, msg: value.ErrMessage, isError: true })
          }
        },
        function (error) {
          console.log("Error: ", error);
        }
      )
  }
  const sendODP = (UserLoginId) => {
    if (UserLoginId == "") {
      setShowAlert(true)
      setAlertMsg("Enter User ID")
    } else {
      const body = {
        LoginID: UserLoginId,
      }
      dispatch(sendOneDayPassword("/LoginV2/GetOneDayPassword", body)).then((res) => {
        if (res?.data?.status === true) {
          setUpdateOdp((prev) => ({
            ...prev,
            open: true,
          }))
        } else {
          setShowAlert(true)
          setAlertMsg(res.data.Message)
        }
      }).catch((error) => {
        console.log("Error: ", error);
      });
    }
  }

  const initializeInactivityTimer = (handleLogout, time) => {
    let inactivityTimeout;
    const logoutTime = time * 60 * 1000; // 15 minutes
    const logout = () => {
      if (JSON.parse(sessionStorage.getItem("loginData"))) {
        handleLogout(true);
        clearTimeout(inactivityTimeout);
      }
    };

    const resetTimer = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(logout, logoutTime);
    };

    const events = ['mousemove', 'keypress'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(inactivityTimeout);
    };
  };
  useEffect(() => {
    if (user?.CompanyID !== '') {
      dispatch(getMasterCodeSessionList({})).then((sessRes) => {
        if (sessRes.status === 200 && sessRes.data.status) {
          dispatch(masterCodeAllValue(sessRes.data.Data.Table))
          let selectedValues = ['SERVICE_CANCEL_BACK_DAYS_FOR_APPLICATION_ADMIN'];
          let RevokeAndSeriveData = sessRes.data.Data.Table?.reduce((acc, curr) => {
            if (selectedValues.includes(curr.CategotyType)) {
              acc[curr.CategotyType] = curr.CategoryValue;
            }
            return acc;
          }, {});
          dispatch(updateRevokeAndSeriveDate({
            SERVICE_CANCEL_DAYS_FOR_APPLICATION_ADMIN: RevokeAndSeriveData?.[selectedValues?.[0]] || 0,
          }))
        } else {
          dispatch(masterCodeAllValue([]))
        }
      })
      const body = {
        UserID: user?.UserID,
        CompanyID: user?.CompanyID,
        BranchID: user?.BranchID,
      }
      dispatch(getCompanyCityPairs(body))
    }
  }, [user?.CompanyID])
  useEffect(() => {
    const cleanup = initializeInactivityTimer(handleLogout, user?.masterCodeValue?.filter((val) => val?.CategotyType === 'SESSION_TIMEOUT')?.[0]?.CategoryValue || 15);
    return cleanup;
  }, [user.loginData, user?.masterCodeValue]);
  const handleLogout = (val) => {
    if (val) {
      const body = {
        intLogID: user?.loginData?.intLogID
      }
      const memcache = new Map()
      dispatch(logoutUser(body))
      sessionStorage.clear();
      memcache.clear();
      navigate("/login");
      dispatch(logout())
    }
  };
  useEffect(() => {
    axios({
      method: "get",
      url: 'https://service.mavenconnect.tech/api/crs/get-my-ip',
      headers: {
        Accept: "application/json",
        Authorization: 'Bearer 32604f91d0a0dd46b5a9efbcc74039f4',
      },
    }).then((res) => {
      dispatch(UpdateIpAddress(res?.data?.ip || ''))
    })
  }, [])
  useEffect(() => {
    if (user?.CompanyID) {
      const placeBody = {
        CityID: 0,
        StateID: 0,
        AttachCityID: 0,
        AttachBranchID: 0,
      }
      dispatch(getplaceListAll(placeBody))
    }
  }, [user?.CompanyID])
  useEffect(() => {
    if (sessionStorage?.getItem('timeConfig') !== null) {
      callGolbleData()
    }
  }, [sessionStorage?.getItem('timeConfig')])
  useEffect(() => {
    let timeoutId;
    if (user?.loginData?.token && sessionStorage?.getItem('timeConfig') !== null) {
      let parts = user?.loginData?.token?.split("||")
      let date_time = parts[0].split("~").pop()
      const timeDifference = moment(date_time).valueOf() - moment(window.getTime ? window.getTime() : new Date()).valueOf();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (timeDifference > 0) {
        timeoutId = setTimeout(() => {
          setShowAlert1(true)
        }, timeDifference);
      } else {
        setShowAlert1(true)
      }
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [user?.loginData?.token, sessionStorage?.getItem('timeConfig')])
  function isTimeLessThanCurrent(timeString) {
    // Parse the provided time string
    var providedTime = new Date(timeString);

    // Get the current time
    var currentTime = new Date();

    // Compare the provided time with the current time
    if (providedTime > currentTime) {
      return "true"; // provided time is less than current time
    } else {
      return "false"; // provided time is equal to or greater than current time
    }
  }
  useEffect(() => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const loginToken = searchParams.get('authentication') || '';
    // const resetPassword = searchParams.get('restPassword') || ''
    const resetPassword = decodeURIComponent(searchParams.get('restPassword') || '');
    if (resetPassword !== '') {
      let resetToken = decryptText(resetPassword.replaceAll(" ", "+"))
      let resetTokendata = resetToken.split('~')
      setLoginId(resetTokendata?.[1])
      var timeString = resetTokendata?.[0];
      var result = isTimeLessThanCurrent(timeString);
      if (result == "true") {

      }
      else {
        navigate("/login")
      }

    }
    if (loginToken == '') {
      const sessToken = sessionStorage.getItem('token');
      const LoginId = sessionStorage.getItem('LoginId');
      setShowLoginId(LoginId || "")
      if (sessToken != null) {
        const userData = sessionStorage.getItem('userData');
        const agentRight = sessionStorage.getItem('agentRight');
        const loginCredential = sessionStorage.getItem('loginData');
        dispatch(log_in(JSON.parse(userData), JSON.parse(agentRight)));
        dispatch(dispatch(loginData(JSON.parse(loginCredential))));
        dispatch(getServerTime(sessToken))
        return;
      }
      else {
        // handleSetAlert("error", "Error Logging In");
      }
    }
    let loginParams = decryptText(loginToken)
    if (loginParams && loginParams != 'ErrorInDecrypting') {
      loginParams = loginParams.split('~')
      if (loginParams.length == 5) {
        const [dateTime, companyID, Code, LoginID, Password] = loginParams;
        const [dateStr, timeStr, meridiem] = dateTime.split(" ");
        const [day, month, year] = dateStr.split('-')
        let [hours, minutes, seconds] = timeStr.split(':')
        if (meridiem === 'PM') {
          hours = +hours
          hours += 12
        }
        const authDateTime = new Date(+year, +monthNames.indexOf(month), +day, +hours, +minutes, +seconds)
        const currentDateTime = new Date()
        const diffTime = Math.abs(currentDateTime - authDateTime)
        const diffHours = Math.ceil(diffTime / (1000 * 60 * 60))
        console.log(diffHours + ' hours')
        console.log('fetching login from server version 0.2')
        if (diffHours < 24) {
          fetchLogin({ Code, LoginID, Password })
        }
        else {
          navigate("/login")
          handleSetAlert("error", "Error Logging In");
        }
      }
    }
    else {
      // handleSetAlert("error", "Error Logging In");
    }
  }, []);


  useEffect(() => {
    const feedbackId = searchParams.get('CN') || '';
    if (feedbackId !== '') {
      sessionStorage.setItem("FeedbackId", feedbackId)
    }
    const macToken = searchParams.get('X') || '';
    if (macToken !== '') {
      sessionStorage.setItem("XToken", macToken)
      navigate("/login")
    }
  }, [])


  // for alert
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("error");

  const handleSetAlert = (type, msg) => {
    if (type === "success")
      setAlertType("success");
    else
      setAlertType("error");
    setAlertMsg(msg);
    setShowAlert(true);
  }

  const handleAlertClose = () => {
    setShowAlert(false);
    // if (window.location.origin.includes('mavenconnect.tech')) window.location.replace('https://mavenconnect.tech/bus')
    // else if (window.location.origin.includes('mavenconnect.biz')) window.location.replace('https://mavenconnect.biz/bus')
    // else window.location.replace('https://mavenconnect.tech/bus')
  }

  const loginCredential = useSelector(state => state.user.loginData)

  useEffect(() => {
    if (user?.CompanyID) {
      const body = {
        CounterID: 0,
        BranchID: user?.BranchID,
        CounterTypeID: 1,
        CompanyID: user?.CompanyID
      }
      dispatch(getCounterTableData(body)).then((res) => {
        if ((res.status === 200 && res.data.status) && res?.data?.Data?.Table.length > 0) {
          let option = res?.data?.Data?.Table.map((val) => ({ ...val, CounterNameID: `${val.CounterName} (${val.CounterCode})` }))
          setCounterOpt(option || [])
          setSelCounter([option[0]])
        } else {
          setCounterOpt([])
        }
      })
    }
  }, [user?.CompanyID])
  useEffect(() => {
    if (user?.CounterID !== undefined) {
      if ((user?.CounterID === 0 && user?.loginData?.AccessBranchID > 0) && !(user?.loginData?.RoleName?.toLowerCase()?.includes('admin')) && (sessionStorage.getItem("userData") !== null && Object.keys(JSON.parse(sessionStorage.getItem("userData"))).length !== 0)) {
        SetShowCounter(true)
      }
      else {
        SetShowCounter(false)
      }
    }
  }, [user?.CounterID, user?.loginData?.AccessBranchID])
  const handleCounter = () => {
    SetShowCounter(false)
    let userData = JSON.parse(sessionStorage.getItem("userData"));
    let loginData = JSON.parse(sessionStorage.getItem("loginData"));
    dispatch(updateUserData({
      ...user, CounterID: selCounter?.[0]?.CounterID, loginData: {
        ...user?.loginData, CounterCode: selCounter?.[0]?.CounterCode, CounterID: selCounter?.[0]?.CounterID,
        POSDeviceID: selCounter?.[0]?.POSDeviceID || '',
        PaymentModeID: selCounter?.[0]?.PaymentModeID,
      }
    }))
    sessionStorage.setItem("userData", JSON.stringify({
      ...userData, CounterID: selCounter?.[0]?.CounterID,
      POSDeviceID: selCounter?.[0]?.POSDeviceID || '',
      PaymentModeID: selCounter?.[0]?.PaymentModeID,
    }));
    sessionStorage.setItem("loginData", JSON.stringify({
      ...loginData,
      CounterCode: selCounter?.[0]?.CounterCode,
      CounterID: selCounter?.[0]?.CounterID,
      POSDeviceID: selCounter?.[0]?.POSDeviceID || '',
      PaymentModeID: selCounter?.[0]?.PaymentModeID,
    }));
    //api call
    const body = {
      LogID: user?.loginData?.intLogID,
      CounterID: selCounter?.[0]?.CounterID
    }
    dispatch(setCounterId(body))
    navigate("/displayNews")
  }
  useEffect(() => {
    if (sessionStorage.getItem('roleData') !== null && user.roleData.length === 0) {
      dispatch(roleData(JSON.parse(sessionStorage.getItem('roleData'))))
    }
  }, [sessionStorage.getItem('roleData')])

  const CounterProps = () => {
    return {
      width: "100%",
      name: "CounterName",
      label: "",
      isCompulsory: false,
      options: counterOpt || [],
      preSelectedValues: selCounter || [],
      searchPlaceholder: "Search by Counter Name",
      disabled: false,
      isObject: true,
      primaryKey: 'CounterID',
      labelKey: 'CounterNameID',
      singleSelect: true,
      selectAllOption: false,
      defaultAllSelected: false,
    }
  }


  return (
    <Suspense fallback={<LoaderScreen />}>
      {location?.pathname === "/CrewReservationchartPrint" && <CrewReservationchartPrint />}
      {
        (!sessionStorage.getItem('token') && (location?.pathname !== "/forgot-password" && (location?.pathname !== "/change-password" && location?.pathname !== "/CrewReservationchartPrint"))) && <Login setShowLoginId={setShowLoginId} fetchLogin={fetchLogin} setError={setError} error={error} passwordReset={passwordReset} setPasswordReset={setPasswordReset} loginError={loginError} setLoginError={setLoginError} updateOdp={updateOdp} setUpdateOdp={setUpdateOdp} callLoginApi={callLoginApi} />
      }
      {user.loading ? <ProgressBar /> : ""}
      {user.loadingScreen && <LoaderScreen />}
      {(sessionStorage.getItem('token') && location?.pathname !== "/change-password") && <KSRTCHeader headerName={user?.UserName} LoginID={showLoginId} />}
      {user.menuVisible && <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => 4 }}
        open={true}
        onClick={() => dispatch(menuVisible())}
      >
      </Backdrop>}
      {sessionStorage.getItem('token') && element}
      {!sessionStorage.getItem('token') && (
        <Routes>
          <Route path="/forgot-password" element={<ForgotPassword loginId={loginId} setError={setError} error={error} />} />
        </Routes>
      )}
      <Routes>
        <Route path="/change-password" element={<ForgotPassword isChgPassword={true} loginId={showLoginId} setError={setError} error={error} />} />
      </Routes>
      <ConfirmCounter open={showCounter} CounterProps={CounterProps} onSelect={(val) => {
        setSelCounter(val)
      }} width={'400px'} onClose={() => {
        if (selCounter.length > 0) {
          handleCounter()
        }
      }} />
      {sessionStorage.getItem('token') && <Footer />}
      {showAlert && <Alert msg={alertMsg} alertType={alertType} close={handleAlertClose} buttonText="Ok" />}
      {showAlert1 && <Alert msg={'Token is Expired'} alertType={alertType} close={() => {
        sessionStorage.clear();
        navigate("/login");
        dispatch(logout())
        setShowAlert1(false)
      }} buttonText="Ok" />}
    </Suspense>
  );
}

export default App;